/**
 * Canonical root URL for the app by environment.
 * Use this anywhere we need to build absolute URLs (redirects, emails, links).
 */
export function getRootUrl(): string {
  switch (process.env.NODE_ENV) {
    case 'production':
      return 'https://share-a-cart.com';
    case 'staging':
      return 'https://cart-a-share.com';
    case 'classroom':
      return 'https://share-a-cart.com:8443';
    default:
      return 'http://localhost:3080';
  }
}

/** Hostname and port (no protocol). */
export function getRootHostname(): string {
  return new URL(getRootUrl()).hostname;
}
